import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AdminRoutingModule } from './admin-routing.module';
import { AdminUtilitiesComponent } from './admin-utilities/admin-utilities.component';
import { AdminComponent } from './admin.component';
import { BreadCrumbNavigationComponent } from './bread-crumb-navigation/bread-crumb-navigation.component';
import { ChecklistDashboardComponent } from './checklist-dashboard/checklist-dashboard.component';
import { EditProgramsDialogComponent } from './dialog-edit-programs/dialog-edit-programs.component';
import { DialogSitePaymentResultsComponent } from './dialog-site-payment-results/dialog-site-payment-results.component';
import { EditAppConfigPageComponent } from './edit-app-config-page/edit-app-config-page.component';
import { EditBuyerPageComponent } from './edit-buyer-page/edit-buyer-page.component';
import { EditCohortPageComponent } from './edit-cohort-page/edit-cohort-page.component';
import { EditLegalPageComponent } from './edit-legal-page/edit-legal-page.component';
import { EditProgramPageComponent } from './edit-program-page/edit-program-page.component';
import { EditReportConfigPageComponent } from './edit-report-config-page/edit-report-config-page.component';
import { EmailAdminComponent } from './email-admin/email-admin.component';
import { ManageAppConfigPageComponent } from './manage-app-config-page/manage-app-config-page.component';
import { ManageBuyersPageComponent } from './manage-buyers-page/manage-buyers-page.component';
import { ManageCohortsPageComponent } from './manage-cohorts-page/manage-cohorts-page.component';
import { ManageDocusignPageComponent } from './manage-docusign-page/manage-docusign-page.component';
import { ManageLegalPageComponent } from './manage-legal-page/manage-legal-page.component';
import { ManageProgramsPageComponent } from './manage-programs-page/manage-programs-page.component';
import { ManageRegionsPageComponent } from './manage-regions-page/manage-regions-page.component';
import { ManageReportConfigPageComponent } from './manage-report-config-page/manage-report-config-page.component';
import { PaymentDashboardComponent } from './payment-dashboard/payment-dashboard.component';
import { SiteApprovalStep1Component } from './site-approval-step-1/site-approval-step-1.component';
import { SiteApprovalStep2Component } from './site-approval-step-2/site-approval-step-2.component';
import { SiteApprovalStep3Component } from './site-approval-step-3/site-approval-step-3.component';
import { SiteDashboardComponent } from './site-dashboard/site-dashboard.component';
import { AdminSiteDetailPageComponent } from './site-detail-page/admin-site-detail-page.component';
import { SiteStatusLogComponent } from './site-status-log/site-status-log.component';
import { CustomPieChartComponent } from './stats-dashboard/custom-pie-chart/custom-pie-chart.component';
import { StatsDashboardComponent } from './stats-dashboard/stats-dashboard.component';
import { UploadRegionComponent } from './upload-region/upload-region.component';
import { AdminUserPermissionsPageComponent } from './user-permissions-page/admin-user-permissions-page.component';

import { SharedModule } from '../../shared';
import { SharedMapModule } from '../../shared-map/shared-map.module';
import { ManageCountiesPageComponent } from "./manage-counties-page/manage-counties-page.component";
import { DragDropModule } from "@angular/cdk/drag-drop";

@NgModule({
  declarations: [
    AdminComponent,
    AdminSiteDetailPageComponent,
    AdminUserPermissionsPageComponent,
    BreadCrumbNavigationComponent,
    DialogSitePaymentResultsComponent,
    AdminUtilitiesComponent,
    EditAppConfigPageComponent,
    EditBuyerPageComponent,
    EditCohortPageComponent,
    EditProgramPageComponent,
    EditLegalPageComponent,
    EditReportConfigPageComponent,
    EditProgramsDialogComponent,
    ManageAppConfigPageComponent,
    ManageBuyersPageComponent,
    ManageCohortsPageComponent,
    ManageCountiesPageComponent,
    ManageDocusignPageComponent,
    ManageLegalPageComponent,
    ManageReportConfigPageComponent,
    ManageProgramsPageComponent,
    ManageRegionsPageComponent,
    EmailAdminComponent,
    PaymentDashboardComponent,
    SiteApprovalStep1Component,
    SiteApprovalStep2Component,
    SiteApprovalStep3Component,
    SiteDashboardComponent,
    ChecklistDashboardComponent,
    SiteStatusLogComponent,
    StatsDashboardComponent,
    CustomPieChartComponent,
    UploadRegionComponent,
  ],
  imports: [AdminRoutingModule, CommonModule, FormsModule, ReactiveFormsModule, SharedMapModule, SharedModule, DragDropModule],
})
export class AdminModule {
}
